import { createContext, useContext } from "react";
import type { ReportLink } from "@/services/report-links";
import type { BiomarkerSummary } from "@/services/report-summary";
import type { ChatSession, Test } from "@/types";

export interface ReportContextValue {
  token: string;
  link: ReportLink;
  test: Test;
  good: BiomarkerSummary[];
  attention: BiomarkerSummary[];
  videoUrl: string | null;
  sessions: ChatSession[];
  setSessions: React.Dispatch<React.SetStateAction<ChatSession[]>>;
}

const ReportContext = createContext<ReportContextValue | null>(null);

export function useReportContext(): ReportContextValue {
  const ctx = useContext(ReportContext);
  if (!ctx) {
    throw new Error(
      "useReportContext must be used inside <PatientReportLayout />",
    );
  }
  return ctx;
}

export const ReportContextProvider = ReportContext.Provider;
